import { apiSlice } from 'state/slices/apiSlice';

const SEARCH_URL = '/search';

export const searchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchUsers: builder.query({
      query: (queryString) => `${SEARCH_URL}?q=${queryString}`,
    }),
  }),
});

export const {
  useSearchUsersQuery,
} = searchApiSlice;